module.exports = __webpack_public_path__ + "static/media/infis.01c05e96.svg";